<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only" >
    <fs1-span><b>{{label || ''}}</b></fs1-span>
    <slot name="top"></slot>
    <v-progress-circular :style="searching?'':'display:none'" indeterminate color="primary" style="height:15px"/>
    <v-combobox
      :class="[(search || disabled || model? '': 'textEmpty'), (disabled?'valueContainer in_rq_disabled':'')]"
      v-model="model"
      :search-input.sync="search"
      :prepend-icon="p_icon"
      :append-icon="a_icon"
      :item-text="item_text"
      :item-value="item_value"
      :disabled="disabled"
      :hide-details="!!condensed || disabled"
      clearable
      multiple
      chips
      small-chips
      deletable-chips
      hide-selected
      ref="in-rq-mlt-combobox"
      @change="change_m"
      @click:clear="(e)=>change_m(null,e)"
      :placeholder="disabled?'':c_placeholder"
      :items="items"
      :md="md || 4"
      no-filter>      
        <template v-slot:item={item}>
          <div>{{item_text_fun(item,item_text)}}</div>
        </template>
        <template v-slot:selection={item}>
        <v-chip small close @click:close="remove(item)">
          {{item_text_fun(item,item_text)}}
        </v-chip>
        </template>
        <template v-slot:append-item>
          <div v-intersect="endIntersect"></div>
        </template>
    </v-combobox>
    <!--  este componenete(v-combobox) funciona con detalles en esta configuracion, especificando item-value model deberia ser un id pero retorna objeto-->
    <slot name="bottom"></slot>
  </pre_input>
</template>
<script>
import pre_input_js from '@/components/mixins/pre_input';
import Debounce from '@/components/Debounce';
import {same_array} from '@/functions/general.js';
const get_objs = (a) => a.filter(i=> typeof i === 'object' && i != null);
export default {
  props:{
    p_icon:{},
    searched:{},
    value:{},
    item_text_fun:{default:()=>{return (t,n)=>t[n] }},
    item_text:{default:'name'},
    item_value:{default:'id'},
    obj_val:{default:()=>[]},
    k_f:{default:`s__name`},
    get_name:{/* default:'critical_asset' */},
    value_not_found:{default:false},//boleano que pasa a true si no se encuentra
    search_not_found:{default:false},//boleano que pasa a true si no se encuentra
    search_ex_filter:{},
    main_name:{},/* name se usara para actualizar la lista , ya que el proceso que hace debounce y otros procesos usan ese atr */
    main_kf:{},
    max:{},
    items_on_search:{default:true},
  },
  mixins: [ Debounce, pre_input_js  ],
  data(){
    return {
      searching:false,
      search:null,
      model: null,
      items: [],

      is_intersecting:false,
      has_next_page:false,
      count:0,
      page:1,
      getting:false,
    }
  },
  watch: {
    'search'(v,v_old){
      this.has_next_page = false;
      this.count = 0;
      this.page = 1;

      this.dev_log(7,{v,v_old});
      this.$emit('update:searched', v);
      this.$emit('update:search_not_found', false);
      this.searching = true;
      if (v) this.debounceM('search', ()=>this.set_model(v,v_old));
      else this.set_model();
    },
    'value'(v,v_old){ 
      if (v === v_old) return;// caso null
      else if (Array.isArray(v) && Array.isArray(v_old) && same_array(v,v_old)) return; //lo mimso
      this.dev_log(6,{v,v_old});
      this.set_model();
    },
    model(v,vo) {
      this.dev_log(11,{v,vo});
    },
    'is_intersecting'(o,v){
      if(this.is_intersecting) this.infiniteScroll();
    }
  },
  created(){
    this.dev_log(0);
    this.set_model();
  },
  methods: {
    remove (item) {
      this.model.splice(this.model.indexOf(item), 1)
      //this.items = [...this.items]
    },
    set_item_text_fun(items){
      /* items.forEach(i=>i[this.item_text]=this.item_text_fun(i,this.item_text))
      console.log({items}); */
      return items;
    },
    /* se usa cuando se selecciona uno de la lista, se busca y es lo unico retornado, se limpia */
    change_m(items,ev){
      const f_items =  this.items.length===1 && this.items[0][this.item_text] == this.search
        ? [...get_objs(this.model)].concat(this.items.filter(i=>!this.model.find(m=>m[this.item_value]===i[this.item_value])))
        : get_objs(items);
      this.dev_log(8,items,this.items,{f_items} ,this.max);
      this.model = f_items;


      if(this.max && this.model.length > this.max) {
        this.dev_log(' you can only select ', this.max , this.model, this.value)
        this.model.shift();
      }
      this.$emit('update:value', (this.model||[]).map(m=>m[this.item_value]) || null);
      this.$emit('update:obj_val', this.model);
      this.$refs['in-rq-mlt-combobox'].isMenuActive = false
      this.items = [];
    },
    set_model() {
      try {
        /* formulario vacio */
        if ((this.value === null || !(this.value||[]).length) && !this.model && !this.search) {
          this.searching = false;
          this.dev_log(1,this.search);
          this.items = [];
          return;
        }
        /* no se a buscado escribiendo pero hay valor, entonces es pq se abrio un formulario con datos */
        if (!this.search && (this.value||[]).length && !(this.model||[]).length) {
          this.dev_log(2,this.value);
          const filter = {page_size:this.value.length};
          filter[this.main_kf] = this.value.join(',');
          this.requests.getsSimple[`${this.get_name}/a/all`](filter)
            .then(r => {
              if (r.results && r.results.length) {
                this.items = [...r.results];
                this.model = [...r.results];
                this.$emit('update:obj_val', this.model);
                this.has_next_page = !!r.next;
              }
              else if (this.value_not_found === false) this.$emit('update:value_not_found', true);
            })         
          return;
        }
        /* busqueda normal tras escribir en el input */
        if (this.search) {
          this.dev_log(3,this.search,this.model);
          const filter = this.search_ex_filter? {...this.search_ex_filter}:{};
          filter[this.k_f] = this.search;
          this.requests.getsSimple[`${this.get_name}/a/all`](filter)
            .then(r=> this.set_item_text_fun((r||{}).results))
            .then(r => {
              this.has_next_page = !!r.next;
              this.searching = false;
              this.items = (((r || {}).results || r) || []);
              this.dev_log('!!!!!',{r});
              if (r.count === 0) this.$emit('update:search_not_found', true);
              if (this.items.length === 1) {
                this.dev_log(9,this.model);
                 
                const search = this.items[0][this.item_text];
                if (search != this.search) this.search = search;
              }
            })
            .catch(e=> this.searching = false)
        }
        this.searching = false;
        this.dev_log(4); 
      } catch (error) {this.searching = false}  
    },

    endIntersect(entries, observer, isIntersecting) {
      //console.log({entries, observer, isIntersecting});
      this.is_intersecting = isIntersecting;
    },
    infiniteScroll() {
      if(this.has_next_page && !this.getting) {
        this.getting = true;
        this.page++;

        const filters = this.search_ex_filter? {...this.search_ex_filter}:{};
        filters[this.k_f] = this.search;
        filters.page = this.page;
        this.requests.getsSimple[`${this.get_name}/a/all`](filters)
          .then(r=> this.set_item_text_fun((r||{}).results))
          .then(r => {
            this.has_next_page = !!r.next;
            if (this.has_next_page === false) this.page--;
            this.count = r.count;
            this.items = this.items.concat(r.results);
            this.getting = false;;
          })
          .catch(e=>{
            this.getError(e);
            this.getting = false;
          })
      }
    },
  },

};
</script>
